import { n as removeTrapFocus, r as trapFocus } from "@theme/theme";
import { o as getEnterDirection, s as getLeaveDirection, t as ALL_BORDER_CLASSES } from "@theme/utils";
import { t as gsapWithCSS } from "@theme/gsap";
//#region frontend/islands/product-details-drawer.js
var ProductDetailsDrawer = class extends HTMLElement {
	constructor() {
		super();
		document.addEventListener("keyup", (evt) => evt.code === "Escape" && this.classList.contains("active") && this.close());
		this.querySelector("#ProductDetailsDrawer-Overlay").addEventListener("click", this.close.bind(this));
		this.setTriggerAccessibility();
		this.initContentTabs();
		this.initRecipeTabs();
	}
	initContentTabs() {
		this.querySelectorAll(".drawer-tab").forEach((tab) => {
			tab.addEventListener("click", () => {
				const oldTab = this.querySelector(".active-tab");
				if (!oldTab || oldTab === tab) return;
				const selector = tab.getAttribute("data-trigger");
				const oldContent = this.querySelector(".active-content");
				const newContent = this.querySelector(`[data-content="${selector}"]`);
				if (!newContent) return;
				oldTab.classList.remove("active-tab", ...ALL_BORDER_CLASSES);
				oldTab.classList.add("border-leave-bottom");
				tab.classList.add("active-tab");
				tab.classList.remove(...ALL_BORDER_CLASSES);
				oldContent.classList.remove("active-content");
				oldContent.classList.add("inactive-content");
				newContent.classList.add("active-content");
				newContent.classList.remove("inactive-content");
			});
			tab.addEventListener("mouseenter", (e) => {
				if (tab.classList.contains("active-tab")) return;
				tab.classList.remove(...ALL_BORDER_CLASSES);
				tab.classList.add(`border-enter-${getEnterDirection(e, tab)}`);
			});
			tab.addEventListener("mouseleave", (e) => {
				if (tab.classList.contains("active-tab")) return;
				tab.classList.remove(...ALL_BORDER_CLASSES);
				tab.classList.add(`border-leave-${getLeaveDirection(e, tab)}`);
			});
		});
	}
	initRecipeTabs() {
		this.querySelectorAll("[data-recipe-tab]").forEach((btn) => {
			btn.addEventListener("click", () => {
				const recipeName = btn.dataset.recipeName;
				if (recipeName && recipeName !== this.dataset.currentRecipe) this.loadRecipe(recipeName);
			});
		});
		document.addEventListener("recipe:change", (e) => {
			if (e.detail.recipeName !== this.dataset.currentRecipe) this.loadRecipe(e.detail.recipeName);
		});
	}
	async loadRecipe(recipeName) {
		const { productHandle, sectionId } = this.dataset;
		const picker = document.querySelector("product-recipe-picker");
		const variantRadios = document.querySelector("variant-radios");
		if (!productHandle || !sectionId || !picker || !variantRadios) return;
		const optionIndex = parseInt(picker.dataset.optionIndex, 10);
		const variant = JSON.parse(variantRadios.querySelector("[type=\"application/json\"]").textContent).find((v) => v.options[optionIndex] === recipeName);
		if (!variant) return;
		const currentPanels = this.querySelector("[data-drawer-panels]");
		const headerImg = this.querySelector("[data-drawer-header-image] img");
		const fadeTargets = [currentPanels, headerImg].filter(Boolean);
		try {
			if (fadeTargets.length) await gsapWithCSS.to(fadeTargets, {
				opacity: .25,
				duration: .3
			});
			const res = await fetch(`/products/${productHandle}?variant=${variant.id}&section_id=${sectionId}`);
			if (!res.ok) {
				if (fadeTargets.length) gsapWithCSS.to(fadeTargets, {
					opacity: 1,
					duration: .3
				});
				return;
			}
			const html = await res.text();
			const newPanels = new DOMParser().parseFromString(html, "text/html").querySelector("[data-drawer-panels]");
			if (!newPanels || !currentPanels) return;
			currentPanels.innerHTML = newPanels.innerHTML;
			if (headerImg) {
				const btn = this.querySelector(`[data-recipe-name="${recipeName}"]`);
				if (btn?.dataset.imageUrl) {
					headerImg.src = btn.dataset.imageUrl;
					await new Promise((resolve) => {
						if (headerImg.complete) return resolve();
						headerImg.addEventListener("load", resolve, { once: true });
						headerImg.addEventListener("error", resolve, { once: true });
					});
				}
			}
			this.dataset.currentRecipe = recipeName;
			this.syncRecipeTabs(recipeName);
			this.resetToNutritionTab();
			gsapWithCSS.to(fadeTargets, {
				opacity: 1,
				duration: .3
			});
		} catch {
			if (fadeTargets.length) gsapWithCSS.to(fadeTargets, {
				opacity: 1,
				duration: .3
			});
		}
	}
	syncRecipeTabs(recipeName) {
		this.querySelectorAll("[data-recipe-tab]").forEach((btn) => {
			btn.classList.toggle("active", btn.dataset.recipeName === recipeName);
		});
	}
	resetToNutritionTab() {
		this.querySelectorAll(".drawer-tab").forEach((tab) => tab.classList.remove("active-tab", ...ALL_BORDER_CLASSES));
		const nutritionTab = this.querySelector("[data-trigger=\"nutrition\"]");
		if (nutritionTab) nutritionTab.classList.add("active-tab");
	}
	setTriggerAccessibility() {
		document.querySelectorAll("[data-product-details-drawer-trigger]").forEach((trigger) => {
			trigger.setAttribute("aria-haspopup", "dialog");
		});
		document.addEventListener("click", (event) => {
			const trigger = event.target.closest("[data-product-details-drawer-trigger]");
			if (!trigger) return;
			event.preventDefault();
			this.open(trigger);
		});
	}
	open(triggeredBy) {
		if (triggeredBy) this.activeElement = triggeredBy;
		setTimeout(() => this.classList.add("active"));
		this.addEventListener("transitionend", () => trapFocus(document.getElementById("ProductDetailsDrawer"), this.querySelector("[tabindex=\"-1\"]")), { once: true });
		document.body.classList.add("overflow-hidden");
	}
	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}
};
window.customElements.define("product-details-drawer", ProductDetailsDrawer);
//#endregion
